export function sortMedicalInsurance (insurences) {
  const convenios = []

  insurences.map(item => {
    convenios.push({ 'nome': item.name,
                      'id': item.id,
                      'notice': item.notice })
  });
  return convenios.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
